
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { IModalComponent, Btn, Field, TextareaField } from '@samc/centricity-core';

  @Component({
    name: 'remove-loans-modal',
    components: { TextareaField, Btn, Field }
  })

  export default class RemoveLoansFromDealModal extends Vue implements IModalComponent {
    @Prop() public addCloseProp!: (callback: () => Promise<any>) => void;
    @Prop() public closeProp!: () => void;
    @Prop({ default: '' }) public initialReason!: string;

    public description: string = this.initialReason;

    public mounted() {
      this.addCloseProp(async () => {
        // Description is optional, so we return it only if it has content.
        if (this.description !== undefined && this.description?.length > 0) {
          return this.description;
        } else {
          return '';
        }
      });
    }
  }

